



























import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import MixDeCategorias from './MixDeCategorias.vue'
import TopPecas from './TopPecas.vue'
import type { CategoriaDoMixDoCliente, TopPecaDoCliente } from '@/models'

@Component({
	components: {
		MixDeCategorias,
		TopPecas,
	},
})
export default class DialogoDeMixETopPecas extends Vue {
	@PropSync('mostra', { type: Boolean, default: false }) aberto!: boolean
	@Prop({ type: Array, default: () => [] }) categorias!: CategoriaDoMixDoCliente[]
	@Prop({ type: Array, default: () => [] }) topPecas!: TopPecaDoCliente[]
}
